export default import.meta.ROLLDOWN_FILE_URL_mXTymr3r2ElSlG4WWqrxow